module.exports = __webpack_public_path__ + "img/maridaje_rose.fcda07d4.jpg";